var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLogin)?[_c('pay-pro-dialog'),_c('pay-erp-dialog'),_c('pay-chars-dialog'),_c('pay-token-dialog'),_c('download-notices'),_c('bind-wechat')]:[_c('div',{staticClass:"absolute top-20 right-20 zindex-10"},[_c('change-client-language')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }